module.exports = __webpack_public_path__ + "img/bill.e306633a.svg";